import * as actionsType from "./actionsType";

export const changestatus = (payload) => {
  return {
    type: actionsType.CHANGE_STATUS,
    payload: payload,
  };
};
